import { useState, useCallback, useMemo } from 'react';

import { usePermissions } from '@minecraft.permissions';
import { useFeatureExperiment, FEATURE_FLAGS } from '@blocs.features-experiments';

export type UseShowSocialLinksParams = {
  storageKey: string;
};

export const useShowSocialLinks = ({ storageKey = 'DEFAULT_SOCIAL_LINK_KEY' }: UseShowSocialLinksParams) => {
  const { ability } = usePermissions();
  const socialLinkingFlagEnabled = useFeatureExperiment(FEATURE_FLAGS.WEB_INSTAGRAM_SOCIAL_LINKING);

  const [displaySocialMediaSection, setDisplaySocialMediaSection] = useState<boolean>(
    localStorage.getItem(storageKey) === 'true'
  );

  const showSocialLinks = ability.can('read', 'social-media') && socialLinkingFlagEnabled;

  const onChangeDisplaySocialMediaSection = useCallback(() => {
    setDisplaySocialMediaSection(!displaySocialMediaSection);
    localStorage.setItem(storageKey, JSON.stringify(!displaySocialMediaSection));
  }, [storageKey, displaySocialMediaSection, setDisplaySocialMediaSection]);

  return useMemo(
    () => ({
      showSocialLinks,
      displaySocialMediaSection,
      onChangeDisplaySocialMediaSection,
    }),
    [showSocialLinks, displaySocialMediaSection, onChangeDisplaySocialMediaSection]
  );
};
